export default __webpack_public_path__ + "static/pool-lounge-c58cb4974d84b5c30710922832ced713.jpg";